export const HARNESS_KEY = process.env.REACT_APP_HARNESS_KEY || '';
export const INDENTIFIER = 'reactclientsdk';
export const NAME = 'ReactClientSDK';
export const IS_HARNESS_PROVIDER = true;
